import { Component, OnInit, ChangeDetectorRef } from "@angular/core";
import { Router, ActivatedRoute, Params, NavigationEnd } from "@angular/router";
import { AppService } from "../../services/app.service";
import { DataService } from "../../services/data.service";
import { UiStateService } from "../../services/ui-state.service";
import { IndividualUserInfo } from "../../models/individual-user-info";
import { Check } from "../../models/check";
import { CustomFormsModule } from "ng2-validation";
import { first } from "rxjs/operators";
import { forkJoin } from "rxjs";
import { Ng2DeviceService } from "ng2-device-detector";

@Component({
  selector: "app-welcome1",
  templateUrl: "./welcome.component.html",
  styleUrls: ["./welcome.component.scss"],
})
export class WelcomeComponent implements OnInit {
  token: string;
  authToken: string;
  countries: any[] = [];

  allDataLoaded: boolean = false;
  individualUserInfo: IndividualUserInfo;
  checks: Check[] = [];
  themingInfo: any;

  checkLinkGUID: string;
  kycOriginCountry: string;

  isCountryUpdatable: boolean;
  isProfileUpdatable: boolean;
  redirectUrl: any;
  
  clientDetails : any;
  //Mobile Vars
  isMobile: boolean;

  audios: any[] = [];
  deviceInfo: any;
  deviceName: string;
  geolocation: string;
  ip: any;
  userName: any='';

  constructor(
    public _app: AppService,
    public _data: DataService,
    public router: Router,
    public route: ActivatedRoute,
    public uiStateService: UiStateService,
    public cdRef: ChangeDetectorRef,
    private deviceService: Ng2DeviceService
  ) {
    this.route.queryParams.subscribe(params => {
      if (params.token) {
        console.log("params.token");
        console.log(params.token);
        this.token = params.token;
        this._data.removeAllCookie(); //Remove All previous sessions
        this._data.setCookieByName("feas_token", this.token);
        //this.getAllDetails();
        // this.getAudios();
      }
      if (params.authtoken) {
        console.log("params.authtoken");
        console.log(params.authtoken);
        this.authToken = params.authtoken;
        this._data.removeAllCookie(); //Remove All previous sessions
        this._data.setCookieByName("auth_token", this.authToken);
      }
    });
    this.deviceInformation()
    
    // this.logActivity()
  }

  ngOnInit() {
    //this.getAccountInfo()
    this.getAllCountries();
    this.route.queryParams.subscribe(({accountType}) => {
      console.log(accountType);
    });
    this.isMobile = this.uiStateService.getIsMobileResolution();
    console.log("isMobile: ", this.isMobile);
    setTimeout(() => {
      this.logActivity();
      this.onClick();
    }, 2000)
    this.getIp();
  }

  getAccountInfo(){
    this.route.queryParams.subscribe(({accountType}) => {
      if (accountType === 'corporate') {
        
        this._app.getAccountInfoforCorp().subscribe(res=>{
          console.log("detauls ",res)
          if(res.client.userName){
            if(res.client)
            {
             this.userName=res.client.userName
            }
          }
    
        })
      } 
      else if(accountType === 'ubo' || accountType === 'director'){
        this._app.getAllInfoforCO().subscribe(res=>{
          console.log("detauls ",res)
          if(res){
            if(res.client){
            this.userName=res.client.userName
            }
          }
          
        })
      }
      else {
        
      }
    })
  }
  getAllCountries() {
    this._app.getAllCountries().subscribe(response => {
      this.countries = response["data"];
      localStorage.setItem("countries", JSON.stringify(this.countries));
    });
  }

  getAudios() {
    var clientAudios$ = this._app.getAudios();
    clientAudios$.subscribe(response => {
      // this.audios = response.data ;
      var audios = response.data;
      for (var key in audios) {
        audios[key] = `data:audio/wav;base64,${audios[key]}`;
      }
      this.audios = audios;
      localStorage.setItem("audios", JSON.stringify(this.audios));
    });
  }

  // getAllDetails() {
  //   var clientConfig$ = this._app.getClientConfig();
  //   var clientDetails$ = this._app.getDetails();
  //   forkJoin([clientConfig$, clientDetails$]).subscribe(
  //     response => {
  //       this.allDataLoaded = true;
  //       // this.themingInfo = response[0].data.dashboardTheme
  //       //   ? JSON.parse(response[0].data.dashboardTheme)
  //       //   : null;
  //       // this.clientDetails = response[0].data;
  //       let det={"data":{"checks":[{"endUserCheckID":"ae791f0f-f7bf-4f92-983d-7af94da878d5","standardCheck":{"name":"ID Doc Check","slug":"id-doc-check","costPerRequest":2.0,"isDashboardCheck":true,"isRemoteCheck":true,"isCorporateCheck":false,"status":"ACTIVE"},"standardCheckGroup":"id-checks","verificationStatus":"CREATED","appSource":"DASHBOARD","registrationIp":"18.132.151.33","isRemoteCheck":true,"startDate":"2021-07-16T11:07:02.000+0000","completionDate":null,"lastModifiedDate":"2021-07-16T11:07:02.000+0000","overrideComment":null,"overriddenBy":null,"clientAdminReview":null,"reviewedByClientAdmin":null},{"endUserCheckID":"674e7a64-eb6a-4e35-9e9d-b68e53a431f8","standardCheck":{"name":"Selfie Check","slug":"selfie-check","costPerRequest":2.0,"isDashboardCheck":false,"isRemoteCheck":true,"isCorporateCheck":false,"status":"ACTIVE"},"standardCheckGroup":"id-checks","verificationStatus":"CREATED","appSource":"DASHBOARD","registrationIp":"18.132.151.33","isRemoteCheck":true,"startDate":"2021-07-16T11:07:02.000+0000","completionDate":null,"lastModifiedDate":"2021-07-16T11:07:02.000+0000","overrideComment":null,"overriddenBy":null,"clientAdminReview":null,"reviewedByClientAdmin":null},{"endUserCheckID":"b0b97904-0713-4bb1-845e-6cac12f61f52","standardCheck":{"name":"Liveness Check","slug":"liveness-check","costPerRequest":2.0,"isDashboardCheck":false,"isRemoteCheck":true,"isCorporateCheck":false,"status":"ACTIVE"},"standardCheckGroup":"id-checks","verificationStatus":"CREATED","appSource":"DASHBOARD","registrationIp":"18.132.151.33","isRemoteCheck":true,"startDate":"2021-07-16T11:07:02.000+0000","completionDate":null,"lastModifiedDate":"2021-07-16T11:07:02.000+0000","overrideComment":null,"overriddenBy":null,"clientAdminReview":null,"reviewedByClientAdmin":null}],"hasRemoteChecks":true,"linkStatus":"SENT","linkSentCount":1,"residenceCountry":"United Kingdom","checkLinkGUID":"90624336-bd00-4157-b45d-bd1e9b289f69","userName":"lander.demere_12","isProfileUpdatable":true,"isCountryUpdatable":true,"individualUserInfo":{"device":null,"os":null,"location":null,"ip":null,"browser":null,"individualUserType":"NORMAL","firstName":"test kp","middleName":null,"lastName":"","dob":null,"gender":null,"placeOfBirthCity":null,"placeOfBirthState":null,"placeOfBirthCountry":null,"fatherName":null,"residenceCountry":{"countryCode":"GB","countryName":"United Kingdom","countrySynonyms":"GB|GBR|UK|","isActive":"ACTIVE","jurisdictions":null},"mobileNumber":""},"corporateUserInfo":null},"message":null,"infoType":"INFO","statusCode":200}
  //       let conf={"data":{"passStp":"AUTO","failStp":"AUTO","allowDifferentCountryIdentityDoc":true,"allowDifferentCountryAddressDoc":true,"logoUrl":"https://placeholder.com/wp-content/uploads/2018/10/placeholder.com-logo1.png","dashboardTheme":"{\"primary\":\"#000000\",\"secondary\":\"#4acbff\",\"background\":\"#000000\",\"buttonbg\":\"#e30f0f\",\"logo\":\"https://placeholder.com/wp-content/uploads/2018/10/placeholder.com-logo1.png\"}","feAsTheme":"{\"name\":\"Delta\",\"slug\":\"delta\",\"isActive\":\"ACTIVE\",\"themeType\":\"FEAS\",\"themeConfig\":\"{    \\\"color-primary\\\":\\\"#565759\\\",    \\\"color-primary-light\\\":\\\"#4c545c\\\",    \\\"color-primary-lighter \\\":\\\"#5d5f61\\\",    \\\"color-primary-dark \\\":\\\"#4b4c4d\\\",    \\\"color-primary-darker \\\":\\\"#363738\\\",    \\\"color-secondary\\\":\\\"#86888a\\\",    \\\"color-secondary-light\\\":\\\"#909396\\\",    \\\"color-secondary-lighter\\\":\\\"#72767a\\\",    \\\"color-secondary-dark \\\":\\\"#6c7175\\\",    \\\"color-secondary-darker\\\":\\\"#5c5959\\\",    \\\"color-kyc-grey \\\":\\\"#383d42\\\" }\",\"createdDate\":\"2019-09-17T07:33:56.000+0000\",\"lastModifiedDate\":\"2020-06-03T04:33:32.000+0000\",\"logo\":\"https://cdn.vox-cdn.com/thumbor/rmlVhlxJt84XTKP6mFXdh3zF6GE=/0x0:1024x512/920x613/filters:focal(431x175:593x337):format(webp)/cdn.vox-cdn.com/uploads/chorus_image/image/66439957/aDzH7sHpSJ9ivMQhPMiwT5_1024_80.0.jpg\",\"welcomeCard__image\":\"https://dcassetcdn.com/design_img/1559024/551167/551167_7840631_1559024_911ff84c_image.png\",\"gettingStarted_image\":\"https://cdn.vox-cdn.com/thumbor/rmlVhlxJt84XTKP6mFXdh3zF6GE=/0x0:1024x512/920x613/filters:focal(431x175:593x337):format(webp)/cdn.vox-cdn.com/uploads/chorus_image/image/66439957/aDzH7sHpSJ9ivMQhPMiwT5_1024_80.0.jpg\"}","redirectUrl":null,"isDefaultMessage":false,"message":"{\"Welcome\":{\"Title\":\"Welcome To KYCHub {{firstName}} {{lastName}}!\",\"Message\":\"Great to see you here brother\",\"Button_Text\":\"Lets Go!\"},\"Terms\":{\"Title\":\"Terms Of Service\",\"Message\":\"<p class='medium-paragraph text-left'>Please read these terms & conditions carefully before proceeding.</p><p class='medium-paragraph'>These terms cover information about data management and process flow.</p><p class='medium-paragraph'>Any Business covered by the Money Laundering Regulations must carryout 'customer due diligence' measures to ensure their customers are who they say they are.</p><strong class='h3-headline'>Who we are & how to contact us</strong><p class='medium-paragraph'>We KYC Hub will take the documents provided by you and process them to verify your identity as per your provided information on behalf of our clients. You have complete authority over your data. We strictly follow GDPR guidelines ensuring proper data protection and security.</p><p class='medium-paragraph'>You can contact us at <a href='mailto: {{mailId}}'>{{mailId}}</a></p><strong class='h3-headline'>Documents</strong><p class='medium-paragraph'>We need your ID documents to proceed. You must produce an original,valid document that confirms your identity.</p>\",\"Label\":\"I accept & agree with all terms & conditions.\",\"Button_Text\":\"Accept & Continue\"},\"Getting_Started\":{\"Title\":\"Welcome OnBoard!\",\"Message\":\"Happy to see you , Please check & fill the details below to proceed.\",\"Labels\":{\"FirstName\":\"Enter First Name\",\"LastName\":\"Enter Last Name\",\"Gender\":\"Choose Gender\",\"Mobile\":\"Enter Mobile Number\",\"DOB\":\"Enter Date Of Birth\",\"Country\":\"Select Country\"},\"Button_Text\":\"Get Started\"},\"Identity_Check\":{\"Title\":\"Upload Identity Document\",\"Message\":\"Upload Valid document that confirms your Identity. Please make sure that your image in the document is clearly visible and there is no glare on it. \",\"Step1\":{\"Country_Label\":\"Select Country\",\"Next\":\"Next\",\"Country_Text\":\"This would be your KYC Country , all Documents & Proofs will correspond to this country only.\"},\"Step2\":{\"Message\":\"Select Personal ID Document Type that you would like to Submit\",\"ChangeCountry\":\"Change Country\"},\"Step3\":{\"Message\":\"Upload {{docName}} Document Front & Back Image\",\"Upload\":\"Click Here to Upload File\",\"Drag\":\"Drag & Drop your files Here\",\"ReUpload\":\"Re Upload\"},\"Button_Text\":\"Get Started\"},\"Address_Check\":{\"Title\":\" Upload Address Document\",\"Message\":\"Upload Valid document that confirms your Address. Please make sure that your image in the document is clearly visible and there is no glare on it. \",\"Upload_Text\":\"Upload {{docName}} Document Front & Back Image\",\"Button_Text\":\"Get Started\"},\"Selfie_Check\":{\"Title\":\"Upload Selfie/Do Liveness Test\",\"Message\":\"Record &amp; upload your video. We will verify the video and provide results.\",\"Direction1\":\"Make Sure Ambience is well lit i.e there is proper lighting.\",\"Direction2\":\"Try to avoid wearing Specs.\",\"Direction3\":\"Make Sure your face is not covered &amp; clearly visible.\",\"Instructions\":\"Instructions\",\"Enable_Camera\":\"Enable Camera\",\"Check\":\"Check your Uploaded Video & Submit.\",\"Retake_button\":\"Retake\"},\"Directions\":{\"One\":\"Please Look Straight At The Camera\",\"Two\":\"Please Turn Your Face To The Right\",\"Three\":\"Please Turn Your Face To The Left\",\"Four\":\"Please Look Straight At The Camera & Blink\"},\"Preview_Check\":{\"Title\":\"Verify your Details\",\"Message\":\"Double check your application that everything is error free. You can go back to edit your application.<strong>Once Submitted you won't be able to make any changes.</strong>\",\"Defaulter\":\"Your browser does not support the video element\"},\"Nav_Buttons\":{\"Next\":\"Next\",\"Previous\":\"Previous\",\"Finish\":\"Finish\",\"Save\":\"Save\",\"Update\":\"Update\",\"Start\":\"Start\",\"Retry\":\"Retry\",\"Stop\":\"Stop\"}}","isoCode":null,"themeSlug":null,"themeType":null,"isDefaultFeasTheme":false,"isDefaultDashboardTheme":false,"isDefaultAudio":false,"clientVerification":null,"selectedFeasTheme":"default","selectedFeasLang":"en","checkCompletionEmail":true,"createdDate":"2019-11-15T06:16:32.000+0000","lastModifiedDate":"2020-10-17T09:54:56.000+0000","isReminderEnabled":true,"enableBiometricSetting":null},"message":null,"infoType":"INFO","statusCode":200}
  //       this.clientDetails = {"data":{"checks":[{"endUserCheckID":"ae791f0f-f7bf-4f92-983d-7af94da878d5","standardCheck":{"name":"ID Doc Check","slug":"id-doc-check","costPerRequest":2.0,"isDashboardCheck":true,"isRemoteCheck":true,"isCorporateCheck":false,"status":"ACTIVE"},"standardCheckGroup":"id-checks","verificationStatus":"CREATED","appSource":"DASHBOARD","registrationIp":"18.132.151.33","isRemoteCheck":true,"startDate":"2021-07-16T11:07:02.000+0000","completionDate":null,"lastModifiedDate":"2021-07-16T11:07:02.000+0000","overrideComment":null,"overriddenBy":null,"clientAdminReview":null,"reviewedByClientAdmin":null},{"endUserCheckID":"674e7a64-eb6a-4e35-9e9d-b68e53a431f8","standardCheck":{"name":"Selfie Check","slug":"selfie-check","costPerRequest":2.0,"isDashboardCheck":false,"isRemoteCheck":true,"isCorporateCheck":false,"status":"ACTIVE"},"standardCheckGroup":"id-checks","verificationStatus":"CREATED","appSource":"DASHBOARD","registrationIp":"18.132.151.33","isRemoteCheck":true,"startDate":"2021-07-16T11:07:02.000+0000","completionDate":null,"lastModifiedDate":"2021-07-16T11:07:02.000+0000","overrideComment":null,"overriddenBy":null,"clientAdminReview":null,"reviewedByClientAdmin":null},{"endUserCheckID":"b0b97904-0713-4bb1-845e-6cac12f61f52","standardCheck":{"name":"Liveness Check","slug":"liveness-check","costPerRequest":2.0,"isDashboardCheck":false,"isRemoteCheck":true,"isCorporateCheck":false,"status":"ACTIVE"},"standardCheckGroup":"id-checks","verificationStatus":"CREATED","appSource":"DASHBOARD","registrationIp":"18.132.151.33","isRemoteCheck":true,"startDate":"2021-07-16T11:07:02.000+0000","completionDate":null,"lastModifiedDate":"2021-07-16T11:07:02.000+0000","overrideComment":null,"overriddenBy":null,"clientAdminReview":null,"reviewedByClientAdmin":null}],"hasRemoteChecks":true,"linkStatus":"SENT","linkSentCount":1,"residenceCountry":"United Kingdom","checkLinkGUID":"90624336-bd00-4157-b45d-bd1e9b289f69","userName":"lander.demere_12","isProfileUpdatable":true,"isCountryUpdatable":true,"individualUserInfo":{"device":null,"os":null,"location":null,"ip":null,"browser":null,"individualUserType":"NORMAL","firstName":"test kp","middleName":null,"lastName":"","dob":null,"gender":null,"placeOfBirthCity":null,"placeOfBirthState":null,"placeOfBirthCountry":null,"fatherName":null,"residenceCountry":{"countryCode":"GB","countryName":"United Kingdom","countrySynonyms":"GB|GBR|UK|","isActive":"ACTIVE","jurisdictions":null},"mobileNumber":""},"corporateUserInfo":null},"message":null,"infoType":"INFO","statusCode":200}
  //       this.clientDetails.feAsTheme = JSON.parse(conf.data.feAsTheme);
  //       console.log(response);
  //       this.themingInfo = {};
  //       this.prepareChecksModel(det);
  //       this.prepareIndividualModel(det);
  //       // this.logActivity();
  //       this.checkLinkGUID = det.data.checkLinkGUID;
  //       this.kycOriginCountry = det.data.residenceCountry;
  //       this.isCountryUpdatable = det.data.isCountryUpdatable;
  //       this.isProfileUpdatable = det.data.isProfileUpdatable;
  //       this.redirectUrl = conf.data.redirectUrl;
  //       this.saveData();
  //       console.log(conf);
  //       console.log(det);
  //       console.log(this.themingInfo);
  //     },
  //     error => {
  //       console.log(error);
  //     }
  //   );
  // }

  prepareIndividualModel(response) {
    this.individualUserInfo = new IndividualUserInfo(
      response.data.individualUserInfo
    );
    this.individualUserInfo.userName = response.data.userName;
  }

  prepareChecksModel(response) {
    if (response.data.checks && response.data.checks.length) {
      for (var i = 0; i < response.data.checks.length; i++) {
        this.checks.push(new Check(response.data.checks[i]));
      }
    }
  }

  onClick(){
    this.route.queryParams.subscribe(({accountType}) => {
      if (accountType === 'corporate') {
        // Todo: add corporate route here        
        this.router.navigate(['welcome'],{
        queryParams: {'accountType': 'corporate'}
        }
        );
      } else if (accountType === 'ubo'){
        this.router.navigate(['welcome'],{
          queryParams: {'accountType': 'ubo'}
          }
          );
      }else if (accountType === 'officer'){
        this.router.navigate(['welcome'],{
          queryParams: {'accountType': 'officer'}
          }
          );
      }else if (accountType === 'director'){
        this.router.navigate(['welcome'],{
          queryParams: {'accountType': 'director'}
          }
          );
      }else if (accountType === 'questionnaire'){
        this.router.navigate(['welcome'],{
          queryParams: {'accountType': 'questionnaire'}
          }
          );
      } else {
        this.router.navigate(['welcome'])
      }
    })
  }

  saveData() {
    this._data.setCookieByName("isCountryUpdatable", this.isCountryUpdatable);
    this._data.setCookieByName("isProfileUpdatable", this.isProfileUpdatable);
    this._data.setCookieByName("redirectUri", this.redirectUrl);
    this._data.setCookieObject("kycOriginCountry", this.kycOriginCountry);
    this._data.setCookieObject("checkLinkGUID", this.checkLinkGUID);
    this._data.setCookieObject("individualUserInfo", this.individualUserInfo);
    localStorage.setItem("remoteChecks", JSON.stringify(this.checks));
    localStorage.setItem("themingInfo", JSON.stringify(this.themingInfo));
  }
  logActivity() {
    let logData = {
     
      os:this.deviceInfo.os,
      browser:this.deviceInfo.browser,
      device:this.deviceName,      
      location:this.geolocation,
      // ip:this.ip
    };
console.log(this.individualUserInfo)
    // this._app
    //   .saveUserActivityLogGetstarted(logData, this.individualUserInfo.userName)
    //   .subscribe(
    //     res => {
    //       console.log(res);
    //     },
    //     err => {
    //       console.log(err);
    //     }
    //   );
  }
  getIp(){
    // this._app.getSystemIp().subscribe((res:any)=>{  
    //   this.ip=res.ip;
    //   console.log("ip adress",this.ip)
    // });
  }
  deviceInformation() {    
    this.deviceInfo = this.deviceService.getDeviceInfo();
    const isMobile = this.deviceService.isMobile();
      const isTablet = this.deviceService.isTablet();
      const isDesktopDevice = this.deviceService.isDesktop();
      if(this.deviceService.device=="unknown"){
        if(isDesktopDevice){
          this.deviceName='Desktop';
        }
        if(isMobile){
          this.deviceName='Mobile';
        }
        if(isTablet){
          this.deviceName='Tablet';
        }
      }else this.deviceName=this.deviceInfo.device;
    console.log("device info",this.deviceName);
    this.getLocation();
    this.getIp()
  }
  getLocation() {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position)=>{
          this._app.getLocation(position.coords.latitude,position.coords.longitude).subscribe(res=>{
            if(res.city==""){
              this.geolocation=`${res.locality}, ${res.countryName}`;
            }else this.geolocation=`${res.city}, ${res.countryName}`;
                
            console.log("location",this.geolocation)      
          });
          
          // this.geolocation=`lat:${position.coords.latitude},lon:${position.coords.longitude}`;
          // console.log("geolcation",this.geolocation);
          // let geocoder = new google.maps.Geocoder();
        });
    } else {
       this.geolocation=null;
    }
}
}
